import React from "react";

const Injection = ({ width, height, color }) => {
  return (
    <svg
      width="42"
      height="42"
      viewBox="0 0 42 42"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M24.7124 8.68841L1 32.4053L9.59304 40.9999L33.3055 17.2831L24.7124 8.68841Z"
        stroke="#435CFF"
        strokeWidth="2"
        strokeLinejoin="bevel"
      />
      <path
        d="M4.8418 37.1566L1.77441 40.2246L1.78529 40.2355L4.85268 37.1675L4.8418 37.1566Z"
        stroke="#435CFF"
        strokeWidth="2"
        strokeLinejoin="bevel"
      />
      <path
        d="M24.8477 18.6934L27.9242 21.7705"
        stroke="#435CFF"
        strokeWidth="2"
        strokeLinejoin="bevel"
      />
      <path
        d="M18.6948 24.8477L21.7714 27.9248"
        stroke="#435CFF"
        strokeWidth="2"
        strokeLinejoin="bevel"
      />
      <path
        d="M12.5415 31.002L15.6181 34.0791"
        stroke="#435CFF"
        strokeWidth="2"
        strokeLinejoin="bevel"
      />
      <path
        d="M29.4624 12.5395L34.0772 7.92383"
        stroke="#435CFF"
        strokeWidth="2"
        strokeLinejoin="bevel"
      />
      <path
        d="M27.1553 1L40.9998 14.8471"
        stroke="#435CFF"
        strokeWidth="2"
        strokeLinejoin="bevel"
      />
    </svg>
  );
};

export default Injection;
